import {
  Grid,
  Typography,
  FormGroup,
  FormControlLabel,
  Checkbox,
  FormControl,
  DialogContent,
  Dialog,
  DialogActions,
  DialogTitle,
  Button,
  TextField,
} from "@material-ui/core";
import React, { useRef, useContext, useState } from "react";
import { useParams } from "react-router-dom";
import { PrimaryButton } from "../../../../Shared/Buttons";
import { AuthContext } from "../../../../Context/Auth";
import axios from "axios";
import DeleteApiBtn from "./DeleteApiBtn";
import OpenSnackbar from "../../../../Shared/OpenSnackbar";

const ApiKey = ({ classes, settings, setSettings }) => {
  const { id } = useParams();
  const { user } = useContext(AuthContext);
  const [isOpen, setIsOpen] = useState(false);
  const [keyName, setKeyName] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbar, setSnackbar] = useState({
    type: "",
    message: "",
  });

  const apiPermissionsArr = [
    "pos/restaurant/status/{orderId}/update",
    "pos/restaurant/menuitem/{item_id}/stock/update",
    "pos/order/{orderId}/data",
    "pos/restaurant/orders/list",
    "pos/restaurant/orders/all",
    "pos/menu/list",
    `pos/restaurant/message/send`,
    `pos/restaurant/email/send`,
    `pos/restaurant/detail/get`,
    "pos/restaurant/payment/pay",
    "pos/create-scan-pay-url",
    "pos/restaurant/setStatus",
    "pos/restaurant/getStatus",
    "pos/restaurant/batch/orders",
  ];

  let dataArr = [];

  const reference = useRef("");
  const delRef = useRef({});

  const handleAPIKeyDelete = (apiKey) => {
    delRef.current = apiKey;
    handleDeletion();
  };

  const updatePermissions = (e) => {
    const { name, value } = e.target;
    let obj = settings?.generalSettings;
    if (!obj.apiKeys[value].is_authorized.includes(name)) {
      obj.apiKeys[value].is_authorized.push(name);
    } else {
      const index = obj.apiKeys[value].is_authorized.indexOf(name);
      if (index > -1) {
        obj.apiKeys[value].is_authorized.splice(index, 1);
      }
    }
    setSettings({ ...settings, generalSettings: obj });
  };

  const handleChange = async () => {
    let obj = {};
    settings.generalSettings.apiKeys.map((key) => {
      if (key.api_key === reference.current) {
        obj = (({ created, is_authorized, status, api_key_name }) => ({
          created,
          is_authorized,
          status,
          api_key_name,
        }))(key);
      }
    });

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}update/apikey/${id}?api_key=${reference.current}`,

        obj
      );

      if (res) {
        setOpenSnackbar(true);

        setSnackbar({
          type: "successDark",
          message: "API permissions updated successfully ",
        });
      }
    } catch (error) {
      if (error.message) {
        setSnackbar({
          type: "errorDark",
          message: error.message,
        });
      }
    }
  };

  const handlePermissions = (e) => {
    const { name } = e.target;
    if (!dataArr.includes(name)) {
      dataArr.push(name);
    } else {
      const index = dataArr.indexOf(name);
      if (index > -1) {
        dataArr.splice(index, 1);
      }
    }
  };

  const handleAddPermissions = async (event) => {
    event.preventDefault();
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_API_URL}apikey/${id}`,
        {
          is_authorized: dataArr,
          api_key_name: keyName,
        }
      );
      if (res) {
        const { api_key, created, api_key_name } = res.data.data;
        const temp = settings.generalSettings;
        let newbody = {
          api_key,
          api_key_name,
          is_authorized: dataArr,
          created,
        };
        temp.apiKeys.push(newbody);
        setSettings({ ...settings, generalSettings: temp });
        setOpenSnackbar(true);
        setSnackbar({
          type: "successDark",
          message: "API key added successfully",
        });
      } else {
        throw new Error("Something went wrong!");
      }
    } catch (error) {
      if (error?.response?.data?.error) {
        setOpenSnackbar(true);
        setSnackbar({
          type: "errorDark",
          message: error?.response?.data?.error,
        });
        return;
      }
      if (error.message) {
        setOpenSnackbar(true);
        setSnackbar({
          type: "errorDark",
          message: error.message,
        });
        return;
      }
    } finally {
      setIsOpen(false);
      setKeyName("");
    }
  };

  const handleDeletion = async () => {
    let tempParent = settings?.generalSettings;
    const tempObj = settings?.generalSettings?.apiKeys;
    let finalIdx = 0;

    tempObj.map((key, index) => {
      if (key == delRef.current) {
        finalIdx = index;
      }
    });

    if (finalIdx > -1) {
      try {
        const res = await axios.post(
          `${process.env.REACT_APP_API_URL}delete/apikey/${id}`,
          {
            api_key: delRef.current.api_key,
            created: delRef.current.created,
          }
        );
        if (res.data) {
          tempObj.splice(finalIdx, 1);
          tempParent.apiKeys = tempObj;

          setOpenSnackbar(true);
          setSnackbar({
            type: "successDark",
            message: "API key deleted successfully",
          });
        } else {
        }
      } catch (error) {
        if (error?.response?.data?.error) {
          setOpenSnackbar(true);
          setSnackbar({
            type: "errorDark",
            message: error.response.data.error,
          });
        } else {
          setOpenSnackbar(true);
          setSnackbar({
            type: "errorDark",
            message: error.message,
          });
        }
      } finally {
        setSettings({ ...settings, generalSettings: tempParent });
      }
    }
  };

  return (
    <>
      <Grid container direction="row" spacing={5}>
        <Grid item xs={12} className={classes.mt30}>
          <Typography variant="h5" className={classes.typographyStyles}>
            API Keys
          </Typography>
          <hr />
          <Grid container>
            {settings?.generalSettings?.apiKeys?.length !== 0 ? (
              settings?.generalSettings?.apiKeys?.map((apiKey, parentIndex) => (
                <>
                  <Grid item xs={12} direction="column" key={parentIndex}>
                    <Typography
                      variant="body1"
                      className={classes.typographyStyles}
                      key={parentIndex}
                      style={{
                        marginTop: "15px",
                        marginBottom: "5px",
                      }}
                    >
                      {`${
                        apiKey.api_key_name
                          ? apiKey.api_key_name
                          : "API Key Name"
                      } :`}{" "}
                      {apiKey.api_key}
                    </Typography>
                    <FormControl>
                      <FormGroup>
                        {apiPermissionsArr.map((permission, index) => (
                          <FormControlLabel
                            control={
                              <Checkbox
                                name={permission}
                                value={parentIndex}
                                color="primary"
                                className={classes.checkboxStyles}
                                checked={
                                  apiKey?.is_authorized?.includes(permission) ||
                                  false
                                }
                                onChange={updatePermissions}
                                inputProps={{
                                  "aria-label": `update_permission_checkbox_${apiKey.api_key}_${index}`,
                                }}
                              />
                            }
                            key={index}
                            label={
                              <Typography
                                variant="body1"
                                className={classes.typographyStyles}
                              >
                                {permission}
                              </Typography>
                            }
                          />
                        ))}
                      </FormGroup>
                    </FormControl>
                  </Grid>
                  <Button
                    color="primary"
                    data-testid={`${apiKey.api_key}_update_permission_btn`}
                    size="small"
                    variant="contained"
                    style={{ marginRight: "1rem" }}
                    name={parentIndex}
                    onClick={() => {
                      reference.current = apiKey.api_key;
                      handleChange();
                    }}
                  >
                    UPDATE PERMISSIONS
                  </Button>
                  <DeleteApiBtn
                    apiKey={apiKey}
                    handleAPIKeyDelete={handleAPIKeyDelete}
                    classes={classes}
                    parentIndex={parentIndex}
                  />
                </>
              ))
            ) : (
              <Typography style={{ marginTop: "10px" }} variant="p">
                No API Keys Found!
              </Typography>
            )}
          </Grid>
          <PrimaryButton
            style={{ marginTop: "20px" }}
            handleClick={() => setIsOpen(true)}
            testId={`add_api_key_btn`}
          >
            ADD API KEY
          </PrimaryButton>
          {isOpen && (
            <Dialog open={isOpen} onClose={() => setIsOpen(false)}>
              <form>
                <DialogTitle className={classes.typographyStyles}>
                  Set API Permissions
                </DialogTitle>
                <DialogContent>
                  <FormGroup>
                    <TextField
                      type="text"
                      placeholder="API key name"
                      value={keyName}
                      error={keyName.length < 3}
                      helperText={
                        keyName.length < 3 && "Please enter valid ApiKey"
                      }
                      onChange={(e) => setKeyName(e.target.value)}
                      inputProps={{
                        "aria-label": "api_key_name_input",
                      }}
                    />
                    {apiPermissionsArr.map((permission, index) => (
                      <FormControlLabel
                        control={
                          <Checkbox
                            name={permission}
                            color="primary"
                            className={classes.checkboxStyles}
                            onChange={handlePermissions}
                          />
                        }
                        key={index}
                        label={
                          <Typography
                            variant="body1"
                            className={classes.typographyStyles}
                          >
                            {permission}
                          </Typography>
                        }
                      />
                    ))}
                  </FormGroup>
                </DialogContent>
                <DialogActions>
                  <Button
                    variant="text"
                    style={{ color: "#09c491" }}
                    onClick={() => setIsOpen(false)}
                    data-testid="cancel_add_api_key_btn"
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    variant="text"
                    id="confirm_add_api_key_btn"
                    style={{ color: "#09c491" }}
                    onClick={handleAddPermissions}
                    data-testid="confirm_add_api_key_btn"
                    disabled={keyName.length < 3}
                  >
                    Add
                  </Button>
                </DialogActions>
              </form>
            </Dialog>
          )}
          <OpenSnackbar
            open={openSnackbar}
            setOpen={setOpenSnackbar}
            message={snackbar.message}
            type={snackbar.type}
            vertical="bottom"
            horizontal="center"
          />
        </Grid>
      </Grid>
    </>
  );
};

export default ApiKey;
